import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';
import { Ag1LoaderComponent } from '../ag1-loader/ag1-loader.component';

@Component({
  selector: 'ag1-grid-loading-overlay',
  template: `
    <div class="grid h-full w-full place-items-center">
      <ag1-loader />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1LoaderComponent],
})
export class Ag1GridLoadingOverlayComponent
  implements ILoadingOverlayAngularComp
{
  public params!: ILoadingOverlayParams & { loadingMessage: string };

  agInit(params: ILoadingOverlayParams & { loadingMessage: string }): void {
    this.params = params;
  }
}
